import axios from 'axios'
import {errorHandlingAppSync} from '../services/helpers'

export default {
  namespaced: true,
  state: {
    jobs: {}
  },
  actions: {
    getJobOutput ({rootState, dispatch}, jobOutputId) {
      let mainResponse
      return axios.post(
        process.env.APPSYNC_URL,
        {
          query: `
          query {
            JobOutput: getJobOutput(id: "${jobOutputId}") {
              job {
                config
                pathKey
                isNested
                sourceFile {
                  pathKey
                }
              }
              id
              analysisId
              objectiveId
              pathKey
              outputFiles(limit: 10000) {
                items {
                  id
                  name
                }
              }
            }
          }`
        },
        {
          headers: {
            Authorization: `${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
        .then((response) => {
          response = errorHandlingAppSync(response)
          mainResponse = response
          if (response.data.JobOutput.job.config.AdditionalConfig) {
            return dispatch('getDownloadURL', {
              sourceFilePathKey: response.data.JobOutput.job.sourceFile.pathKey,
              jobPathKey: response.data.JobOutput.job.pathKey,
              filename: 'additional_config.json'
            }, {root: true})
              .then((response) => {
                return dispatch('getURLData', {url: response.data.url}, {root: true})
              })
              .then((data) => {
                mainResponse.data.JobOutput.job.config = Object.assign(
                  mainResponse.data.JobOutput.job.config, data.data
                )
                return mainResponse
              })
          } else {
            return response
          }
        })
    },
    getNestedJobs ({rootState, commit}, pathKey) {
      return axios.post(
        process.env.APPSYNC_URL,
        {
          query:
          `query {
            allJobs: jobByParentPathKey(parentPathKey: "${pathKey}") {
              items {
                id
                pathKey
                config
                parentPathKey
                importance
                quantity
                isNested
                isArchived
                createdAt
                updatedAt
                sourceFile {
                  id
                  pathKey
                }
                jobOutputs {
                  items {
                    id
                    pathKey
                    analysisId
                    objectiveId
                    outputFiles(limit: 10000) {
                      items {
                        id
                        name
                      }
                    }
                  }
                }
              }
            }
          }`
        },
        {
          headers: {
            Authorization: `${rootState.user.token}`,
            'Content-Type': 'application/json'
          }
        }
      )
        .then((response) => {
          response = errorHandlingAppSync(response)
          return response
        })
    },
    archiveJob ({rootState, commit}, payload) {
      let data = {
        isArchived: true
      }
      if (payload.hasOwnProperty('jobOutputPathKey')) {
        data.jobOutputPathKey = payload.jobOutputPathKey
      } else {
        data.jobPathKey = payload.jobPathKey
      }
      return axios.post(
        `${rootState.config.API_URL}/jobs/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`
          }
        }
      )
    },
    unarchiveJob ({rootState, commit}, payload) {
      let data = {
        isArchived: false
      }
      if (payload.hasOwnProperty('jobOutputPathKey')) {
        data.jobOutputPathKey = payload.jobOutputPathKey
      } else {
        data.jobPathKey = payload.jobPathKey
      }
      return axios.post(
        `${rootState.config.API_URL}/jobs/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`
          }
        }
      )
    },
    deleteJob ({rootState, commit}, job) {
      return axios.post(
        `${rootState.config.API_URL}/jobs/delete`,
        {
          jobPathKey: job
        },
        {
          headers: {
            Authorization: `Bearer ${rootState.user.token}`
          }
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/jobs.js